// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 774 ? "framework" : chunkId) + "-" + {"223":"317c1000e51dd5e7292b","231":"84ad7f267ca2b0dded0f","774":"7a68b783371b7e8b1898"}[chunkId] + ".js";
};